const groupWealthDetailAccountFeatureFields = (fields) => {
  const introFields = fields.filter((field) => field.key === 'title');
  const featureGroups = [];

  for (let index = 1; index <= 20; index += 1) {
    const groupFields = fields
      .filter((field) => field.key.startsWith(`feature-${index}-`))
      .sort((a, b) => a.sortOrder - b.sortOrder);

    if (!groupFields.some((field) => field.key === `feature-${index}-label`)) {
      break;
    }

    featureGroups.push({ index, fields: groupFields });
  }

  return { introFields, featureGroups };
};

export default groupWealthDetailAccountFeatureFields;
